import { formatDateToISO } from 'components/common/FieldFormat';
import { CardCreationType, CardType, Gender } from 'services/profile/constants';

const isCypress = window.hasOwnProperty('Cypress');

const init = (gtmId: string): void => {
  const scriptEl = document.createElement('script');
  scriptEl.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`;
  document.head.insertBefore(scriptEl, document.head.childNodes[0]);

  const noScriptEl = document.createElement('noscript');
  noScriptEl.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  document.body.insertBefore(noScriptEl, document.body.childNodes[0]);
};

const sendEmailDuringUserConnection = (email: string): void => {
  if (!isCypress) {
    (window as any).dataLayer.push({ ClientId: email });
  }
};

const sendSignupStartCPA = (): void => {
  if (!isCypress) {
    (window as any).dataLayer.push({ event: 'signupStartCPA' });
  }
};

const sendSignupSubmitCPA = (): void => {
  if (!isCypress) {
    (window as any).dataLayer.push({ event: 'signupSubmitCPA' });
  }
};

const sendJoinFamiliplusCreate = (): void => {
  if (!isCypress) {
    (window as any).dataLayer.push({ event: 'joinFamiliplusCreate' });
  }
};

const getCardCreationTypeText = (creationType: CardCreationType): string => {
  switch (creationType) {
    case CardCreationType.Create:
      return 'creation';
    case CardCreationType.Link:
      return 'liaison';
  }
};

const getCardTypeText = (cardType: CardType): string => {
  switch (cardType) {
    case CardType.Physical:
      return 'carte physique';
    case CardType.Virtual:
      return 'carte virtuelle';
  }
};

const sendJoinFamiliplusSubmit = (creationType: CardCreationType, cardType: CardType): void => {
  if (!isCypress) {
    (window as any).dataLayer.push({
      event: 'joinFamiliplusSubmit',
      creationType: getCardCreationTypeText(creationType),
      carteType: getCardTypeText(cardType),
    });
  }
};

const sendJoinFamiliplusSkip = (): void => {
  if (!isCypress) {
    (window as any).dataLayer.push({ event: 'joinFamiliplusSkip' });
  }
};

const getGenderText = (gender: Gender | undefined): string => {
  switch (gender) {
    case Gender.Male:
      return 'homme';
    case Gender.Female:
      return 'femme';
    case Gender.Other:
      return 'non-genre';
    default:
      return 'inconnu';
  }
};

const sendMemberShopping = (gender: Gender | undefined, birthday: Date | undefined): void => {
  if (!isCypress) {
    (window as any).dataLayer.push({
      event: 'memberShopping',
      memberPreferences: `${getGenderText(gender)};${birthday ? formatDateToISO(birthday) : 'null'};`,
    });
  }
};

const getBooleanText = (bool: boolean | undefined): string => {
  switch (bool) {
    case true:
      return 'oui';
    case false:
      return 'non';
    default:
      return 'null';
  }
};

const getListStringText = (list: string[]): string => {
  if (list.length == 0) {
    return 'null';
  }
  return list.join('-');
};

const sendMemberCommunication = (
  language: string | undefined,
  newsletterConsent: boolean,
  newsletterTypes: string[],
  smsConsent: boolean | undefined,
  profilingConsent: boolean,
  interests: string[]
): void => {
  if (!isCypress) {
    (window as any).dataLayer.push({
      event: 'memberCommunication',
      memberPreferences: `${language ? language : 'null'};${getBooleanText(newsletterConsent)};${getListStringText(newsletterTypes)};${getBooleanText(smsConsent)};${getBooleanText(profilingConsent)};${getListStringText(interests)}`,
    });
  }
};

export default {
  init,
  sendEmailDuringUserConnection,
  sendSignupStartCPA,
  sendSignupSubmitCPA,
  sendJoinFamiliplusCreate,
  sendJoinFamiliplusSubmit,
  sendJoinFamiliplusSkip,
  sendMemberShopping,
  sendMemberCommunication,
};
